import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import LeaderboardBoard from "../affiliates/LeaderboardBoard";

// SALES-028 follow-up: the points leaderboard used to sit above the Salespeople
// table and pushed it far down the page. It now has its own tab. It holds the
// leaderboard, the base-vs-extension breakdown per rep (the row secondary) and
// the plain-language basis note, and follows the page's period picker like the
// other tabs. Everyone who can open Sales Performance sees it — reps included,
// since points carry no money. LeaderboardBoard itself is untouched.
export function PointsTab({ range }) {
  // SALES-028 follow-up: points count from October 1, 2026. A period ENTIRELY
  // before that day shows a note instead of an empty board.
  const POINTS_START = "2026-10-01";
  const beforeStart = !!(range?.to && range.to < POINTS_START);

  const { data: pointsData } = useQuery({
    queryKey: ["sales-points", range.from, range.to],
    queryFn: async () => (await api.get("/sales-performance/points", {
      params: { from: range.from || undefined, to: range.to || undefined },
    })).data,
  });

  // Rank defensively from a sorted COPY (points desc, then name) rather than
  // trusting the response order, so ranks can't silently break if the API ever
  // returns unsorted rows. Shared places: equal points share a rank.
  let _rank = 0, _prevPts = null;
  const pointsBoard = {
    rows: [...(pointsData?.rows || [])]
      .sort((a, b) => (b.points - a.points) || (a.salesperson || "").toLowerCase().localeCompare((b.salesperson || "").toLowerCase()))
      .map((r, i) => {
        if (r.points !== _prevPts) { _rank = i + 1; _prevPts = r.points; }
        return { ...r, rank: _rank };
      }),
  };

  return (
    <div className="space-y-2" data-testid="points-tab">
      {beforeStart ? (
        <div className="border border-border bg-card p-8 text-center text-sm text-muted-foreground" data-testid="points-before-start">
          Points started on October 1, 2026
        </div>
      ) : (
        <div data-testid="points-leaderboard-section">
          <LeaderboardBoard
            board={pointsBoard}
            testid="points-leaderboard"
            showArrows={false}
            heading="Points leaderboard"
            subheading="Ranked by points earned in the selected period"
            note="One point when a car goes out, plus one for every five days a rental is extended after it went out, up to four points per booking each month. Points count from October 1, 2026, and only for names on the salespeople list."
            noteTestid="points-basis-hint"
            nameKey="salesperson"
            metricKey="points"
            metricUnit="points"
            secondary={(r) => `${r.base} car-out · ${r.extension} extension`}
            emptyText="No points in this period yet."
          />
        </div>
      )}
    </div>
  );
}
